import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=74842bdc&scoped=true"
import script from "./TableCard.vue?vue&type=script&lang=js"
export * from "./TableCard.vue?vue&type=script&lang=js"
import style0 from "./TableCard.vue?vue&type=style&index=0&id=74842bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74842bdc",
  null
  
)

export default component.exports